export const standardChart = {
    chart: {
      zoomType: 'xy',
      animation: false,
      marginTop: 50,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      height: '600px',
      backgroundColor: 'rgba(255, 255, 255, 0)',
      style: {
        fontFamily: 'Montserrat'
      }
    },
    credits: {
      enabled: false
    },
    title: {
      text: null
    },
    subtitle: {
      text: null
    },
    exporting: {
      enabled: false
    },
    legend: {
      enabled: false,
    },

};
  
/**
 * Array of subsequent numbers, startNum and endNum are included in the range.
 */
export const numberRange = (startNum, endNum) => {
  const years = []; 
  while ( startNum <= endNum) {
      years.push(startNum++);
  }   
  return years;
};